<template>
  <div class="form form-sp-0">
    <el-form style="margin:20px;width:75%;min-width:600px;" label-width="180px">
      <el-form-item class='edit-form w100' label="销售下单号">
        <span>{{Form.OrderCode}}</span>
      </el-form-item>
      <el-form-item class='edit-form w100' label="发货通知单号">
        <span>{{Form.SendCode}}</span>
      </el-form-item>

      <el-form-item class='edit-form w100' label="代理商">
        <span>{{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>
      </el-form-item>

      <el-form-item class='edit-form w100' label="要求发货时间" v-show="false">
        <span>{{Form.RequireSendDate}}</span>
      </el-form-item>
      <el-form-item class='edit-form w100' label="实际发货时间">
        <span>{{Form.SendTime}}</span>
      </el-form-item>
      <el-form-item class='edit-form w100' label="实际签收时间">
        <span>{{Form.SignDate}}</span>
      </el-form-item>

      <div v-show="Form.ProjectType==2">
        <el-form-item class='edit-form w100' label="Hi幼教样机数量">
          <span>{{Form.ProtoTypeNum}}</span>
        </el-form-item>
        <el-form-item class='edit-form w100' label="样机已抵扣数">
          <span>{{Form.ProtoTypeDeductibleNum}}</span>
        </el-form-item>
        <el-form-item class='edit-form w100' label="此单需抵扣数">
          <span>{{Form.OrderProtoTypeDeductibleNum}}</span>
        </el-form-item>
      </div>

      <el-form-item class='edit-form' label="套餐名称" v-show="Form.PackageName!=''">
        <span>{{Form.PackageName}}</span>
      </el-form-item>

      <el-form-item class='edit-form' label="发货情况">
        <el-radio-group style="width:300px;" @change="SendStatus" v-model="SendGood">
          <el-radio-button label="全部发货" value="1"></el-radio-button>
          <el-radio-button label="部分发货" value="2"></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item class='edit-form' label="商品" v-show="Form.ListGoods!=''" style="width:100%">

        <el-table :data="Form.ListGoods" border style="width: 100%;">
          <el-table-column prop="ProName" label="名称">
          </el-table-column>
          <el-table-column label="包含单品" width="240">
            <template scope="scope">
              <div v-if="scope.row.PackDetail.length==0">--</div>
              <div v-else class="dpDvCtnCss">
                <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ProductNum" label="总数">
          </el-table-column>
          <el-table-column prop="Nums" label="应发数">
          </el-table-column>
          <el-table-column label="实发" width="200px">
            <template scope="scope">
              <el-input-number v-model="scope.row.ActualNum" :disabled="NumShow" :min="0" :max="scope.row.Num" size="small" style="display: flex;justify-content: center;"></el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item class='edit-form' label="赠品" v-show="Form.GiftGoods!=''" style="width:100%">
        <el-table :data="Form.GiftGoods" border style="width: 100%;  ">
          <el-table-column prop="ProName" label="名称">
          </el-table-column>
          <el-table-column label="包含单品" width="240">
            <template scope="scope">
              <div v-if="scope.row.PackDetail.length==0">--</div>
              <div v-else class="dpDvCtnCss">
                <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ProductNum" label="总数">
          </el-table-column>
          <el-table-column prop="Nums" label="应发数">
          </el-table-column>
          <el-table-column label="实发" width="200px">
            <template scope="scope">
              <el-input-number v-model="scope.row.ActualNum" :disabled="NumShow" :min="0" :max="scope.row.Num" size="small" style="display: flex;justify-content: center;"></el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item class='edit-form' label="电视机机型" v-show="false">
        <div v-for="(item,index) in getDsjTypeList">
          <p>{{item.ProName}}</p>
          <p v-for="(itemc,indexc) in item.info">
            <input type="text" :placeholder="itemc.ProName" />
          </p>
        </div>
      </el-form-item>
      <el-form-item label="租用申请表" v-show="Form.ApplyPic.length>0">
        <div class="show-img-ctn uclear">
          <template v-for="(item,index) in Form.ApplyPic">
            <div class="show-img-cell" @click="LookPicture(item.Url)">
              <img :alt="item.Name" :src="item.Url" />
            </div>
          </template>
        </div>
      </el-form-item>
      <el-form-item class='edit-form w100' label="收货地址">
        <span>{{Form.AgentConsignee}}</span>
      </el-form-item>
      <el-form-item class='edit-form w100' label="收货人及联系方式">
        <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
      </el-form-item>
      <el-form-item class='edit-form w100' label="订单备注">
        <span>{{Form.OrderRemark}}</span>
      </el-form-item>
      <el-form-item class='edit-form w100' label="财务审核备注">
        <span>{{Form.AuditRemark}}</span>
      </el-form-item>
      <el-form-item class='edit-form' label="寄送方式">
        <span>{{Form.SendModeName}}</span>
      </el-form-item>
      <el-form-item class='edit-form' label="支付方式">
        <span>{{Form.PayModeName}}</span>
      </el-form-item>
      <el-form-item class='edit-form' label="快递或物流名称">
        <el-select placeholder="请选择" style="width: 100px" v-model="AddForm.LogisticsId">
          <el-option v-for="option in Logistics" :value="option.Id" :label="option.ParmName">
          </el-option>
        </el-select>
        <el-button icon="plus" @click="showDialog"></el-button>
      </el-form-item>
      <el-form-item class='edit-form' label="快递或物流单号">
        <el-input placeholder="快递或物流单号" style="width:200px" v-model="AddForm.LogisticsCode"></el-input>
      </el-form-item>
      <el-form-item class='edit-form w100' label="包裹件数">
        <el-input placeholder="包裹件数" style="width:20%" v-model="AddForm.PackageNum"></el-input> 件
      </el-form-item>
      <el-form-item class='edit-form' label="备注">
        <el-input type="textarea" style="width:500px;" v-model="AddForm.Remark"></el-input>
      </el-form-item>
      <el-dialog v-model="PictureVisible" size="small">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </el-form>
    <el-row>
      <el-col :span="12" style="text-align:right;">
        <el-button @click="viewSure">返回</el-button>&nbsp;&nbsp;&nbsp;
      </el-col>
      <el-col :span="12" style="">
        <el-button type="primary" @click="submitForm">确定</el-button>
      </el-col>
    </el-row>
    <el-dialog title="快递/物流管理" v-model="visibleShow" size="tiny" :close-on-click-modal="false" v-on:close="dialogClosed">
      <el-table :data="Logistics" style="width: 100%">
        <el-table-column prop="ParmName" label="名称" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template scope="scope">
            <el-button size="small" icon="delete" type="danger" @click="delLogistics(scope.row)">
              删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="16" style="margin-left: 20px">
            <el-input v-model="dialogContent"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="addLogistics">添 加</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import NProgress from "nprogress";
import {
  GetStockOutBySendId,
  GetThirdStockOutBySendId
} from "@api/sendGoodsApi.js";
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";
import { GetParmConfig, ParmConfigDel, ParmConfigAdd } from "@api/commonApi.js";
import {
  ERP_StockOutAdd,
  LoadThirdStockOutByIdForUpdate,
  ERP_StockOutUpdate
} from "@api/stockOutApi.js";
import $http from "$http";

module.exports = {
  data() {
    return {
      loading: false,
      dialogImageUrl: "",
      PictureVisible: false,
      IsUpdate: false,
      Form: {
        ApplyPic: []
      }, //查看内容
      mapDsj: new Object(), //map:电视机机型
      dsjTypeList: [], //list:电视机机型
      Logistics: [], //物流
      SendGood: "",
      NumShow: false,
      visibleShow: false, //物流弹窗
      dialogContent: "",
      AddForm: {
        SendId: "", //编号3
        LogisticsCode: "", //快递单号
        LogisticsId: "", //快递类型
        GoodsList: [],
        GiftsList: [],
        PackageNum: 0,
        type: "0", //非智趣互联
        Remark: ""
      }
    };
  },
  watch: {
    dsjTypeList: {
      deep: true,
      handler() {}
    }
  },
  computed: {
    getDsjTypeList() {},
    isShowIsFirst() {
      if (this.Form.IsFirst > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    viewSure() {
      window.history.go(-1);
    },
    LookPicture(Url) {
      this.dialogImageUrl = Url;
      this.PictureVisible = true;
    },
    getMapDsj(list) {},
    getTCinfo(list) {
      let str = [];
      const h = this.$createElement;
      list.forEach(function(value) {
        //str+=`<p>|--商品:${value.ProName}  数量:+${value.Num}</p>`;
        str.push(
          h(
            "p",
            { style: "font-size:14px;padding-bottom:10px;font-weight:bold;" },
            `商品:${value.ProName}  数量:${value.Num}`
          )
        );
      });

      this.$msgbox({
        title: "套餐详情",
        message: h("p", null, str),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(action => {});
    },
    showDialog() {
      this.visibleShow = true;
    },
    dialogClosed() {
      this.dialogContent = "";
      this.visibleShow = false;
    },
    delLogistics(item) {
      let para = {
        Ids: item.Id
      };
      ParmConfigDel(para).then(res => {
        util.doResult(this, res, () => {
          this.getLogistics();
          for (var i = 0; i < this.Logistics.length; i++) {
            if (this.Logistics[i].Id == item.Id) {
              this.AddForm.LogisticsId = "";
            }
          }
        });
      });
    },
    addLogistics() {
      var para = {
        ParmType: 10,
        ParmName: this.dialogContent
      };
      ParmConfigAdd(para).then(res => {
        util.doResult(this, res, () => {
          this.getLogistics("1");
          this.dialogContent = "";
          this.visibleShow = false;
        });
      });
    },
    SendStatus: function() {
      if (this.SendGood == "全部发货") {
        this.NumShow = true;
        for (var i = 0; i < this.Form.ListGoods.length; i++) {
          this.Form.ListGoods[i].ActualNum = this.Form.ListGoods[i].Num;
        }
        for (var i = 0; i < this.Form.GiftGoods.length; i++) {
          this.Form.GiftGoods[i].ActualNum = this.Form.GiftGoods[i].Num;
        }
      } else {
        this.NumShow = false;
      }
    },
    submitForm() {
      this.AddForm.GoodsList = [];
      this.AddForm.GiftsList = [];
      this.AddForm.SendId = this.$route.query.Id;
      this.loading = true;
      if (this.Form.ListGoods.length > 0) {
        for (var i = 0; i < this.Form.ListGoods.length; i++) {
          var a = {};
          a.ProId = this.Form.ListGoods[i].ProductId;
          a.ProNum = this.Form.ListGoods[i].ActualNum;
          this.AddForm.GoodsList.push(a);
        }
      }

      if (this.Form.GiftGoods.length > 0) {
        for (var i = 0; i < this.Form.GiftGoods.length; i++) {
          var a = {};
          a.ProId = this.Form.GiftGoods[i].ProductId;
          a.ProNum = this.Form.GiftGoods[i].ActualNum;
          this.AddForm.GiftsList.push(a);
        }
      }

      var flag = util.checkForm({
        ele: this,
        rules: [
          {
            name: "包裹件数",
            value: this.AddForm.PackageNum,
            required: true,
            isNumber: true,
            more0: true
          }
        ]
      });

      if (!flag) {
        return;
      }

      if (this.IsUpdate == true) {
        this.AddForm.StockOutId = this.$route.query.StockOutId;
        this.AddForm.SendId = this.Form.SendId;
        ERP_StockOutUpdate(this.AddForm).then(res => {
          util.doResult(this, res, () => {
            this.loading = false;
            this.$notify({
              title: "成功",
              message: "更新出库单成功",
              type: "success"
            });
            util.redirect(this, "/StockOut/StockOutHX", false);
          });
        });
      } else {
        // POST /api/StockOut/StockOutAddV2
        $http.post("api/StockOut/StockOutAddV3", this.AddForm).then(res => {
          this.loading = false;
          util.doResult(this, res, () => {
            this.$notify({
              title: "成功",
              message: "生成出库单成功",
              type: "success"
            });
            util.redirect(this, "/SendGoods/SendGoodsForHX", false);
          });
        });
        // ERP_StockOutAdd(this.AddForm).then(res => {
        //   util.doResult(this, res, () => {
        //     this.loading = false;
        //     this.$notify({
        //       title: "成功",
        //       message: "生成出库单成功",
        //       type: "success"
        //     });
        //     util.redirect(this, "/SendGoods/SendGoodsForHX", false);
        //   });
        // });
      }
    },
    getLogistics(type) {
      let _session = util.getSessin();
      let para = {
        Sid: _session[0],
        Session: _session[1],
        ParmType: 10
      };

      GetParmConfig(para).then(res => {
        util.doResult(this, res, () => {
          this.Logistics = res.data.Data;
          this.loading = false;
          if (type == "1") {
            this.AddForm.LogisticsId = this.Logistics[
              this.Logistics.length - 1
            ].Id;
            this.AddForm.LogisticsId = this.Logistics[
              this.Logistics.length - 1
            ].Id;
          }
        });
      });
    },
    getList1() {
      for (var key in this.mapDsj) {
        this.dsjTypeList.push(this.mapDsj[key]);
      }
    }
  },
  created: function() {
    let _session = util.getSessin();
    let a = {
      Sid: _session[0],
      Session: _session[1],
      ParmType: 10
    };

    GetParmConfig(a).then(res => {
      util.doResult(this, res, () => {
        this.Logistics = res.data.Data;
        if (
          this.$route.query.Id != undefined &&
          this.$route.query.Sid != undefined &&
          this.$route.query.Session != undefined
        ) {
          let para = {
            Sid: _session[0],
            Session: _session[1],
            SendId: this.$route.query.Id
          };
          GetThirdStockOutBySendId(para).then(res => {
            util.doResult(this, res, () => {
              this.Form = res.data.Data;
            });
          });
        }

        if (this.$route.query.StockOutId != undefined) {
          this.IsUpdate = true;
          let para = {
            Sid: _session[0],
            Session: _session[1],
            Id: this.$route.query.StockOutId
          };
          LoadThirdStockOutByIdForUpdate(para).then(res => {
            util.doResult(this, res, () => {
              this.Form = res.data.Data;
              this.AddForm.LogisticsCode = this.Form.LogisticsCode;
              this.AddForm.LogisticsId = this.Form.LogisticsId * 1;
              this.AddForm.Remark = this.Form.Remark;
              this.SendGood = this.Form.CurrentSendStatus;
            });
          });
        }
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.form-sp-0 {
  span {
    margin-left: 0px;
  }
}

.dpDvCss {
  border-bottom: 1px solid #ccc;
  line-height: 34px;
}

.dpDvCtnCss .dpDvCss:last-child {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// AddStockOutHX.vue?25b13ae8